export default "__VITE_ASSET__DKTzaoya__"